import { useContext } from 'react';
import { UIStateContext } from './context';

export const useUIState = () => {
    const context = useContext(UIStateContext);
    return context;
};